module.exports = __webpack_public_path__ + "static/media/add_post_image.f6b113c5.png";